import { unparse } from 'papaparse';
import { downloadZip } from 'client-zip';
import { deflateSync, strToU8 } from 'fflate';

//obsolete, please use downloadFile()
export function downloadFileByUrl(filename: string, url: string) {
	const a = document.createElement('a');
	a.href = url;
	a.setAttribute('download', filename);
	document.body.appendChild(a);
	a.click();
	a.remove();
}

export function downloadFileByBlob(filename: string, blob: Blob) {
	const a = document.createElement('a');
	a.download = filename;
	a.href = URL.createObjectURL(blob);
	a.rel = 'noopener';
	a.target = '_blank';
	document.body.append(a);
	a.click();
	a.remove();
}

export async function downloadFiles(
	items: { url?: string; filename: string; blob?: Blob }[],
	zipFilename: string,
) {
	if (!items.length) {
		return;
	}

	const blobs: Blob[] = [];
	for (let ind = 0; ind < items.length; ind++) {
		const url = items[ind].url;
		const blob = items[ind].blob;
		if (url) {
			blobs.push(await (await fetch(url)).blob());
		}
		if (blob) {
			blobs.push(blob);
		}
	}

	let filename;
	let downloadBlob;
	if (items.length > 1) {
		filename = zipFilename;
		downloadBlob = await downloadZip(
			blobs.map((blob, ind) => new File([blob], items[ind].filename)),
		).blob();
	} else {
		filename = items[0].filename;
		downloadBlob = blobs[0];
	}

	downloadFileByBlob(filename, downloadBlob);
}

export async function downloadBlobsAsZip(
	zipFilename: string,
	blobs: any[],
	filenames: string[],
	forceZip?: boolean,
) {
	if (!blobs.length) {
		return;
	}

	let filename = zipFilename;
	let downloadBlob;

	if (forceZip || blobs.length > 1) {
		filename = zipFilename;
		const files = [];
		for (let i = 0; i < blobs.length; i++) {
			files.push(new File([blobs[i]], filenames[i]));
		}
		downloadBlob = await downloadZip(files).blob();
	} else {
		filename = filenames[0];
		downloadBlob = blobs[0];
	}

	downloadFileByBlob(filename, downloadBlob);
}

//to replace downloadFileByUrl
export async function downloadFile(filename: string, url: string) {
	//a dummy file name files.zip will never be seen, but don't risk putting a string name here
	return downloadFiles([{ url, filename }], 'files.zip');
}

export function toCsvFile(data: any[][], fields: string[]) {
	const csvData = unparse(
		{ fields, data },
		{
			quotes: false,
			quoteChar: '"',
			escapeChar: '"',
			delimiter: ',',
			header: true,
			newline: '\r\n',
		},
	);
	// Need this BOM for Excel (especially on Windows) to work correctly with non-English(e.g. Chinese) charactors
	// https://stackoverflow.com/a/17879474/6228451
	const BOM = '\uFEFF';
	const blob = new Blob([BOM + csvData], { type: 'text/csv; charset=utf-8' });
	return blob;
}

export function toBlob(data: string, contentType = '', sliceSize = 512) {
	const byteCharacters = data;
	const byteArrays = [];

	for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		const slice = byteCharacters.slice(offset, offset + sliceSize);

		const byteNumbers = new Array(slice.length);
		for (let i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);
		byteArrays.push(byteArray);
	}

	const blob = new Blob(byteArrays, { type: contentType });
	return blob;
}

export function binaryStringToUint8Array(binary: string) {
	const len = binary.length;
	const bytes = new Uint8Array(len);
	for (let i = 0; i < len; i++) {
		bytes[i] = binary.charCodeAt(i);
	}
	return bytes;
}

export function labeledLinkify(str?: string) {
	if (!str) {
		return str;
	}

	try {
		const exp = /(?:(?:https?|ftp):\/\/)?[\w/\-?=%.]+\.[\w/\-?=%.]+/;
		const expLinkLabel = /^\[(.*?)\]/;

		const textspans = [];
		let currentStr = str;
		let match = exp.exec(currentStr);
		while (match) {
			const text = currentStr.substring(0, match.index);
			if (text) {
				textspans.push(`<span>${text}</span>`);
			}
			let url = match[0];
			currentStr = currentStr.substring(match.index + url.length);

			let label = url;
			const labelMatch = expLinkLabel.exec(currentStr);
			if (labelMatch) {
				label = labelMatch[1];
				currentStr = currentStr.substring(labelMatch.index + label.length + 2);
			}

			if (!url.includes(':')) {
				url = 'https://' + url;
			}

			textspans.push(
				`<a href="${url}" noopener="true" noreferrer="true" target="_blank">${label}</a>`,
			);
			match = exp.exec(currentStr);
		}
		if (currentStr) {
			textspans.push(`<span>${currentStr}</span>`);
		}
		return textspans.join('');
	} catch (e) {
		console.error(e);
		return '';
	}
}

function uint8ToBase64(bytes: Uint8Array) {
	const chunkSize = 0x8000;
	let binary = '';
	for (let i = 0; i < bytes.length; i += chunkSize) {
		const chunk = bytes.subarray(i, i + chunkSize);
		binary += String.fromCharCode(...chunk);
	}
	return btoa(binary);
}

export function compressJsonToString(value: unknown) {
	const json = JSON.stringify(value);
	const compressed = deflateSync(strToU8(json));
	return uint8ToBase64(compressed);
}
